import { get_native16zxqjg6lrtlz as get_native } from '../NativeElement.commonHtml.mjs';
import {
  _Dimension___get_value__impl__urhqzrblez9tu1bx9v as _Dimension___get_value__impl__urhqzr,
  Dimensions32ju1l7z4mh as Dimension,
  Companion_getInstance2h9rm1uihk6zf as Companion_getInstance,
} from '../../models/data.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  beforeSetupo2ti5mxo1sd1 as beforeSetup,
  beforeSetuptvxu5ozf0s97 as beforeSetup_0,
  beforeSetupw9y6lebwkk6y as beforeSetup_1,
  beforeSetup2j3kmslavpq8h as beforeSetup_2,
  beforeSetupui10dg5zhiof as beforeSetup_3,
} from '../ElementWriter.ext.mjs';
import { NativeContainerElement390em0tm6yzca as NativeContainerElement } from '../NativeContainerElement.commonHtml.mjs';
import {
  Companion_getInstanceztgx4sy4wjnt as Companion_getInstance_0,
  ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement,
} from '../NativeElement.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { KiteUiCoroutineScopeHelpers25rj47zs39igb as KiteUiCoroutineScopeHelpers } from '../KiteUiCoroutineScopeHelpers.mjs';
import { Companion_getInstance29ka8gqgdrya1 as Companion_getInstance_1 } from '../../models/ScreenTransitions.mjs';
import { PopoverSemantic_getInstanceyx37zl2h0qnj as PopoverSemantic_getInstance } from '../../models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../themeDerivations.mjs';
import { text189ciz0cnr32o as text } from './shortcuts.mjs';
import { reactive2xic0rufq5s8n as reactive } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { FloatingInfoHolder1eisb99cxddo9 as FloatingInfoHolder } from './FloatingInfoHolder.js.mjs';
import {
  nativeAnimateHide1mu8gbca9fcry as nativeAnimateHide,
  nativeAnimateShowk0jqs20cr8om as nativeAnimateShow,
} from './modifiers.commonHtml.js.mjs';
import { get_areAnimationsEnabled315dhlyuxowng as get_areAnimationsEnabled } from '../Element.ext.js.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Companion_instance3sky7m0l0l4tp as Companion_instance } from './Frame.commonHtml.mjs';
import { get_px8ok5q0jdway2 as get_px } from '../../models/data.commonHtml.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function sizedBox(_this__u8e3s4, constraints) {
  return beforeSetup(_this__u8e3s4, ($this$beforeSetup) => {
    var tmp;
    var tmp_0 = constraints.minHeight_1;
    if ((tmp_0 == null ? null : new (Dimension())(tmp_0)) == null) {
      // Inline function 'com.lightningkite.kiteui.views.minHeight' call
      get_native($this$beforeSetup).style_1.native_1.minHeight = null;
      tmp = Unit_instance;
    } else {
      var tmp0 = get_native($this$beforeSetup).style_1;
      // Inline function 'com.lightningkite.kiteui.views.minHeight' call
      var value = _Dimension___get_value__impl__urhqzr(constraints.minHeight_1).toString();
      tmp0.native_1.minHeight = value;
      tmp = Unit_instance;
    }
    var tmp_1;
    var tmp_2 = constraints.maxHeight_1;
    if ((tmp_2 == null ? null : new (Dimension())(tmp_2)) == null) {
      // Inline function 'com.lightningkite.kiteui.views.maxHeight' call
      get_native($this$beforeSetup).style_1.native_1.maxHeight = null;
      tmp_1 = Unit_instance;
    } else {
      var tmp0_0 = get_native($this$beforeSetup).style_1;
      // Inline function 'com.lightningkite.kiteui.views.maxHeight' call
      var value_0 = _Dimension___get_value__impl__urhqzr(constraints.maxHeight_1).toString();
      tmp0_0.native_1.maxHeight = value_0;
      tmp_1 = Unit_instance;
    }
    var tmp_3;
    var tmp_4 = constraints.minWidth_1;
    if ((tmp_4 == null ? null : new (Dimension())(tmp_4)) == null) {
      // Inline function 'com.lightningkite.kiteui.views.minWidth' call
      get_native($this$beforeSetup).style_1.native_1.minWidth = null;
      tmp_3 = Unit_instance;
    } else {
      var tmp0_1 = get_native($this$beforeSetup).style_1;
      // Inline function 'com.lightningkite.kiteui.views.minWidth' call
      var value_1 = _Dimension___get_value__impl__urhqzr(constraints.minWidth_1).toString();
      tmp0_1.native_1.minWidth = value_1;
      tmp_3 = Unit_instance;
    }
    var tmp_5;
    var tmp_6 = constraints.maxWidth_1;
    if ((tmp_6 == null ? null : new (Dimension())(tmp_6)) == null) {
      // Inline function 'com.lightningkite.kiteui.views.maxWidth' call
      get_native($this$beforeSetup).style_1.native_1.maxWidth = null;
      tmp_5 = Unit_instance;
    } else {
      var tmp0_2 = get_native($this$beforeSetup).style_1;
      // Inline function 'com.lightningkite.kiteui.views.maxWidth' call
      var value_2 = _Dimension___get_value__impl__urhqzr(constraints.maxWidth_1).toString();
      tmp0_2.native_1.maxWidth = value_2;
      tmp_5 = Unit_instance;
    }
    var tmp_7;
    if (constraints.aspectRatio_1 == null) {
      get_native($this$beforeSetup).setStyleProperty_wavvb3_k$('aspect-ratio', null);
      tmp_7 = Unit_instance;
    } else {
      get_native($this$beforeSetup).setStyleProperty_wavvb3_k$('aspect-ratio', '' + constraints.aspectRatio_1 + ' / 1');
      tmp_7 = Unit_instance;
    }
    var tmp_8;
    var tmp_9 = constraints.width_1;
    if ((tmp_9 == null ? null : new (Dimension())(tmp_9)) == null) {
      // Inline function 'com.lightningkite.kiteui.views.width' call
      get_native($this$beforeSetup).style_1.native_1.width = null;
      tmp_8 = Unit_instance;
    } else {
      var tmp0_3 = get_native($this$beforeSetup).style_1;
      // Inline function 'com.lightningkite.kiteui.views.width' call
      var value_3 = _Dimension___get_value__impl__urhqzr(constraints.width_1).toString();
      tmp0_3.native_1.width = value_3;
      tmp_8 = Unit_instance;
    }
    var tmp_10;
    var tmp_11 = constraints.height_1;
    if ((tmp_11 == null ? null : new (Dimension())(tmp_11)) == null) {
      // Inline function 'com.lightningkite.kiteui.views.height' call
      get_native($this$beforeSetup).style_1.native_1.height = null;
      tmp_10 = Unit_instance;
    } else {
      var tmp0_4 = get_native($this$beforeSetup).style_1;
      // Inline function 'com.lightningkite.kiteui.views.height' call
      var value_4 = _Dimension___get_value__impl__urhqzr(constraints.height_1).toString();
      tmp0_4.native_1.height = value_4;
      tmp_10 = Unit_instance;
    }
    return Unit_instance;
  });
}
function align(_this__u8e3s4, horizontal, vertical) {
  return beforeSetup_0(_this__u8e3s4, ($this$beforeSetup) => {
    get_native($this$beforeSetup).classes_1.add_utx5q5_k$('h' + horizontal.toString());
    get_native($this$beforeSetup).desiredHorizontalGravity_1 = horizontal;
    get_native($this$beforeSetup).classes_1.add_utx5q5_k$('v' + vertical.toString());
    get_native($this$beforeSetup).desiredVerticalGravity_1 = vertical;
    return Unit_instance;
  });
}
function get_asBanner(_this__u8e3s4) {
  return new (ApplyTag())('header', _this__u8e3s4);
}
function weight(_this__u8e3s4, amount) {
  return beforeSetup_1(_this__u8e3s4, ($this$beforeSetup) => {
    var tmp0 = get_native($this$beforeSetup).style_1;
    // Inline function 'com.lightningkite.kiteui.views.flexGrow' call
    var value = '' + amount;
    tmp0.native_1.flexGrow = value;
    var tmp0_0 = get_native($this$beforeSetup).style_1;
    // Inline function 'com.lightningkite.kiteui.views.flexShrink' call
    var value_0 = '' + amount;
    tmp0_0.native_1.flexShrink = value_0;
    // Inline function 'com.lightningkite.kiteui.views.flexBasis' call
    get_native($this$beforeSetup).style_1.native_1.flexBasis = '0';
    var tmp0_safe_receiver = $this$beforeSetup.get_parent_hy4reb_k$();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_native(tmp0_safe_receiver);
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.classes_1;
    if (tmp2_safe_receiver == null)
      null;
    else
      tmp2_safe_receiver.add_utx5q5_k$('childHasWeight');
    return Unit_instance;
  });
}
function get_asNavigation(_this__u8e3s4) {
  return new (ApplyTag())('nav', _this__u8e3s4);
}
function get_asMain(_this__u8e3s4) {
  return new (ApplyTag())('main', _this__u8e3s4);
}
var PassthroughContainerClass;
function PassthroughContainer() {
  if (PassthroughContainerClass === VOID) {
    class $ extends NativeContainerElement() {
      constructor(context) {
        super(context);
        this.native_1.tag_1 = 'div';
        // Inline function 'com.lightningkite.kiteui.views.display' call
        this.native_1.style_1.native_1.display = 'flex';
      }
      nativeAddChild_hge4nv_k$(index, element) {
        element.get_underlyingNativeElement_vngz33_k$().set_themeBase_daz04n_k$(Companion_getInstance_0().fromParentNonCascading_1);
        super.nativeAddChild_hge4nv_k$(index, element);
        // Inline function 'com.lightningkite.kiteui.views.flexGrow' call
        element.get_underlyingNativeElement_vngz33_k$().native_1.style_1.native_1.flexGrow = '1';
      }
    }
    initMetadataForClass($, 'PassthroughContainer');
    PassthroughContainerClass = $;
  }
  return PassthroughContainerClass;
}
var ApplyTagClass;
function ApplyTag() {
  if (ApplyTagClass === VOID) {
    class $ {
      constructor(tag, wraps) {
        this.tag_1 = tag;
        this.wraps_1 = wraps;
        this.wrapperElement_1 = null;
      }
      willAddChild_hz2iwc_k$(element) {
        if (get_native(element).tag_1 === 'span' || get_native(element).tag_1 === 'div') {
          this.wrapperElement_1 = null;
          get_native(element).tag_1 = this.tag_1;
          this.wraps_1.willAddChild_hz2iwc_k$(element);
        } else {
          var we = new (PassthroughContainer())(this.wraps_1.get_context_h02k06_k$());
          we.native_1.tag_1 = this.tag_1;
          this.wraps_1.willAddChild_hz2iwc_k$(we);
          we.willAddChild_hz2iwc_k$(element);
          this.wrapperElement_1 = we;
        }
      }
      addChild_2qpft2_k$(element) {
        var tmp0_safe_receiver = this.wrapperElement_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp0_safe_receiver.addChild_2qpft2_k$(element);
          tmp0_safe_receiver.onStartup_vrxh3i_k$();
          this.wraps_1.addChild_2qpft2_k$(tmp0_safe_receiver);
          tmp = Unit_instance;
        }
        if (tmp == null) {
          this.wraps_1.addChild_2qpft2_k$(element);
        }
      }
      get_context_h02k06_k$() {
        return this.wraps_1.get_context_h02k06_k$();
      }
      invoke_bnq13k_k$(_this__u8e3s4, actionToCalculate) {
        return this.wraps_1.invoke_bnq13k_k$(_this__u8e3s4, actionToCalculate);
      }
      get_coroutineContext_115oqo_k$() {
        return this.wraps_1.get_coroutineContext_115oqo_k$();
      }
    }
    initMetadataForClass($, 'ApplyTag', VOID, VOID, [KiteUiCoroutineScopeHelpers()]);
    ApplyTagClass = $;
  }
  return ApplyTagClass;
}
function shownWhen(_this__u8e3s4, default_0, transition, condition) {
  default_0 = default_0 === VOID ? false : default_0;
  transition = transition === VOID ? Companion_getInstance_1().None_1 : transition;
  // Inline function 'com.lightningkite.kiteui.views.lazyInjectModifierWriter' call
  return new (shownWhen$$inlined$lazyInjectModifierWriter$1())(_this__u8e3s4, _this__u8e3s4, default_0, condition, transition);
}
function setupAsListContainer(_this__u8e3s4) {
  if (get_native(_this__u8e3s4).tag_1 === 'div' || get_native(_this__u8e3s4).tag_1 === 'span')
    get_native(_this__u8e3s4).tag_1 = 'ul';
}
function get_asListItem(_this__u8e3s4) {
  return new (ApplyTag())('li', _this__u8e3s4);
}
function shownForQuery(_this__u8e3s4, query) {
  return beforeSetup_2(_this__u8e3s4, ($this$beforeSetup) => {
    get_native($this$beforeSetup).classes_1.add_utx5q5_k$($this$beforeSetup.get_context_h02k06_k$().kiteUiCss_1.querySet_4t8jxf_k$(query));
    return Unit_instance;
  });
}
function textPopover(_this__u8e3s4, message) {
  return hintPopover(_this__u8e3s4, VOID, ($this$hintPopover) => {
    text(themed($this$hintPopover, PopoverSemantic_getInstance()), message);
    return Unit_instance;
  });
}
function dynamicSizeConstraints(_this__u8e3s4, constraints) {
  return beforeSetup(_this__u8e3s4, ($this$beforeSetup) => {
    reactive($this$beforeSetup, VOID, ($this$reactive) => {
      // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
      var constraints_0 = constraints($this$reactive);
      var tmp;
      var tmp_0 = constraints_0.minHeight_1;
      if ((tmp_0 == null ? null : new (Dimension())(tmp_0)) == null) {
        // Inline function 'com.lightningkite.kiteui.views.minHeight' call
        get_native($this$beforeSetup).style_1.native_1.minHeight = null;
        tmp = Unit_instance;
      } else {
        var tmp0 = get_native($this$beforeSetup).style_1;
        // Inline function 'com.lightningkite.kiteui.views.minHeight' call
        var value = _Dimension___get_value__impl__urhqzr(constraints_0.minHeight_1).toString();
        tmp0.native_1.minHeight = value;
        tmp = Unit_instance;
      }
      var tmp_1;
      var tmp_2 = constraints_0.maxHeight_1;
      if ((tmp_2 == null ? null : new (Dimension())(tmp_2)) == null) {
        // Inline function 'com.lightningkite.kiteui.views.maxHeight' call
        get_native($this$beforeSetup).style_1.native_1.maxHeight = null;
        tmp_1 = Unit_instance;
      } else {
        var tmp0_0 = get_native($this$beforeSetup).style_1;
        // Inline function 'com.lightningkite.kiteui.views.maxHeight' call
        var value_0 = _Dimension___get_value__impl__urhqzr(constraints_0.maxHeight_1).toString();
        tmp0_0.native_1.maxHeight = value_0;
        tmp_1 = Unit_instance;
      }
      var tmp_3;
      var tmp_4 = constraints_0.minWidth_1;
      if ((tmp_4 == null ? null : new (Dimension())(tmp_4)) == null) {
        // Inline function 'com.lightningkite.kiteui.views.minWidth' call
        get_native($this$beforeSetup).style_1.native_1.minWidth = null;
        tmp_3 = Unit_instance;
      } else {
        var tmp0_1 = get_native($this$beforeSetup).style_1;
        // Inline function 'com.lightningkite.kiteui.views.minWidth' call
        var value_1 = _Dimension___get_value__impl__urhqzr(constraints_0.minWidth_1).toString();
        tmp0_1.native_1.minWidth = value_1;
        tmp_3 = Unit_instance;
      }
      var tmp_5;
      var tmp_6 = constraints_0.maxWidth_1;
      if ((tmp_6 == null ? null : new (Dimension())(tmp_6)) == null) {
        // Inline function 'com.lightningkite.kiteui.views.maxWidth' call
        get_native($this$beforeSetup).style_1.native_1.maxWidth = null;
        tmp_5 = Unit_instance;
      } else {
        var tmp0_2 = get_native($this$beforeSetup).style_1;
        // Inline function 'com.lightningkite.kiteui.views.maxWidth' call
        var value_2 = _Dimension___get_value__impl__urhqzr(constraints_0.maxWidth_1).toString();
        tmp0_2.native_1.maxWidth = value_2;
        tmp_5 = Unit_instance;
      }
      var tmp_7;
      if (constraints_0.aspectRatio_1 == null) {
        get_native($this$beforeSetup).setStyleProperty_wavvb3_k$('aspect-ratio', null);
        tmp_7 = Unit_instance;
      } else {
        get_native($this$beforeSetup).setStyleProperty_wavvb3_k$('aspect-ratio', '' + constraints_0.aspectRatio_1 + ' / 1');
        tmp_7 = Unit_instance;
      }
      var tmp_8;
      var tmp_9 = constraints_0.width_1;
      if ((tmp_9 == null ? null : new (Dimension())(tmp_9)) == null) {
        // Inline function 'com.lightningkite.kiteui.views.width' call
        get_native($this$beforeSetup).style_1.native_1.width = null;
        tmp_8 = Unit_instance;
      } else {
        var tmp0_3 = get_native($this$beforeSetup).style_1;
        // Inline function 'com.lightningkite.kiteui.views.width' call
        var value_3 = _Dimension___get_value__impl__urhqzr(constraints_0.width_1).toString();
        tmp0_3.native_1.width = value_3;
        tmp_8 = Unit_instance;
      }
      var tmp_10;
      var tmp_11 = constraints_0.height_1;
      if ((tmp_11 == null ? null : new (Dimension())(tmp_11)) == null) {
        // Inline function 'com.lightningkite.kiteui.views.height' call
        get_native($this$beforeSetup).style_1.native_1.height = null;
        tmp_10 = Unit_instance;
      } else {
        var tmp0_4 = get_native($this$beforeSetup).style_1;
        // Inline function 'com.lightningkite.kiteui.views.height' call
        var value_4 = _Dimension___get_value__impl__urhqzr(constraints_0.height_1).toString();
        tmp0_4.native_1.height = value_4;
        tmp_10 = Unit_instance;
      }
      return Unit_instance;
    });
    return Unit_instance;
  });
}
function hintPopover(_this__u8e3s4, preferredDirection, setup) {
  preferredDirection = preferredDirection === VOID ? Companion_getInstance().belowRight_1 : preferredDirection;
  return beforeSetup_3(_this__u8e3s4, ($this$beforeSetup) => {
    var floating = new (FloatingInfoHolder())($this$beforeSetup);
    floating.menuGenerator_1 = setup;
    floating.preferredDirection_1 = preferredDirection;
    var tmp0 = get_native($this$beforeSetup);
    // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
    var name = 'contextmenu';
    var tmp0_safe_receiver = tmp0.element_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp0_safe_receiver.addEventListener(name, (it) => {
        floating.open_fm36nu_k$();
        return Unit_instance;
      });
      tmp = Unit_instance;
    }
    if (tmp == null) {
      // Inline function 'kotlin.run' call
      var tmp_0 = tmp0.eventsBack_1['on' + name];
      var old = (!(tmp_0 == null) ? typeof tmp_0 === 'function' : false) ? tmp_0 : null;
      var tmp_1 = 'on' + name;
      tmp0.eventsBack_1[tmp_1] = (it) => {
        var tmp0_safe_receiver = old;
        if (tmp0_safe_receiver == null)
          null;
        else
          tmp0_safe_receiver(it);
        floating.open_fm36nu_k$();
        return Unit_instance;
      };
    }
    var tmp0_0 = get_native($this$beforeSetup);
    // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
    var name_0 = 'mouseenter';
    var tmp0_safe_receiver_0 = tmp0_0.element_1;
    var tmp_2;
    if (tmp0_safe_receiver_0 == null) {
      tmp_2 = null;
    } else {
      tmp0_safe_receiver_0.addEventListener(name_0, (it) => {
        floating.open_fm36nu_k$();
        return Unit_instance;
      });
      tmp_2 = Unit_instance;
    }
    if (tmp_2 == null) {
      // Inline function 'kotlin.run' call
      var tmp_3 = tmp0_0.eventsBack_1['on' + name_0];
      var old_0 = (!(tmp_3 == null) ? typeof tmp_3 === 'function' : false) ? tmp_3 : null;
      var tmp_4 = 'on' + name_0;
      tmp0_0.eventsBack_1[tmp_4] = (it) => {
        var tmp0_safe_receiver = old_0;
        if (tmp0_safe_receiver == null)
          null;
        else
          tmp0_safe_receiver(it);
        floating.open_fm36nu_k$();
        return Unit_instance;
      };
    }
    var tmp0_1 = get_native($this$beforeSetup);
    // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
    var name_1 = 'mouseleave';
    var tmp0_safe_receiver_1 = tmp0_1.element_1;
    var tmp_5;
    if (tmp0_safe_receiver_1 == null) {
      tmp_5 = null;
    } else {
      tmp0_safe_receiver_1.addEventListener(name_1, (it) => {
        floating.close_yn9xrc_k$();
        return Unit_instance;
      });
      tmp_5 = Unit_instance;
    }
    if (tmp_5 == null) {
      // Inline function 'kotlin.run' call
      var tmp_6 = tmp0_1.eventsBack_1['on' + name_1];
      var old_1 = (!(tmp_6 == null) ? typeof tmp_6 === 'function' : false) ? tmp_6 : null;
      var tmp_7 = 'on' + name_1;
      tmp0_1.eventsBack_1[tmp_7] = (it) => {
        var tmp0_safe_receiver = old_1;
        if (tmp0_safe_receiver == null)
          null;
        else
          tmp0_safe_receiver(it);
        floating.close_yn9xrc_k$();
        return Unit_instance;
      };
    }
    return Unit_instance;
  });
}
var shownWhen$1Class;
function shownWhen$1() {
  if (shownWhen$1Class === VOID) {
    class $ extends NativeContainerElement() {
      constructor($default, $this_shownWhen, $condition, $transition) {
        super($this_shownWhen.get_context_h02k06_k$());
        this.native_1.tag_1 = 'div';
        this.native_1.classes_1.add_utx5q5_k$('noInteraction');
        this.native_1.classes_1.add_utx5q5_k$('kiteui-stack');
        this.set_shown_mavbz5_k$($default);
        var currentState = {_v: $default};
        reactive(this, VOID, ($this$reactive) => {
          var tmp;
          if (get_areAnimationsEnabled(this) && this.fullyStarted_1) {
            // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
            var c = $condition($this$reactive);
            if (!(c === currentState._v)) {
              if (c) {
                nativeAnimateShow(this, $transition);
              } else {
                nativeAnimateHide(this, $transition);
              }
            }
            currentState._v = c;
            tmp = Unit_instance;
          } else {
            // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
            var c_0 = $condition($this$reactive);
            if (!(c_0 === currentState._v)) {
              this.set_shown_mavbz5_k$(c_0);
            }
            currentState._v = c_0;
            tmp = Unit_instance;
          }
          return Unit_instance;
        });
      }
      nativeAddChild_hge4nv_k$(index, element) {
        protoOf(NativeContainerElement()).nativeAddChild_hge4nv_k$.call(this, index, element);
        element.get_underlyingNativeElement_vngz33_k$().set_themeBase_daz04n_k$(Companion_getInstance_0().fromParentNonCascading_1);
        Companion_instance.internalAddChildStack_5el07d_k$(this, index, element);
      }
      get_spacingForChildCornerRadii_uorqcm_k$() {
        var tmp0_safe_receiver = this.get_parent_hy4reb_k$();
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_spacingForChildCornerRadii_uorqcm_k$();
        var tmp;
        var tmp_0 = tmp1_elvis_lhs;
        if ((tmp_0 == null ? null : new (Dimension())(tmp_0)) == null) {
          tmp = get_px(0);
        } else {
          tmp = tmp1_elvis_lhs;
        }
        return tmp;
      }
    }
    initMetadataForClass($);
    shownWhen$1Class = $;
  }
  return shownWhen$1Class;
}
var shownWhen$$inlined$lazyInjectModifierWriter$1Class;
function shownWhen$$inlined$lazyInjectModifierWriter$1() {
  if (shownWhen$$inlined$lazyInjectModifierWriter$1Class === VOID) {
    class $ {
      constructor($this, $this_shownWhen, $default, $condition, $transition) {
        this.$this_1 = $this;
        this.$this_shownWhen_1 = $this_shownWhen;
        this.$default_1 = $default;
        this.$condition_1 = $condition;
        this.$transition_1 = $transition;
        this.$$delegate_0__1 = $this;
        this.current_1 = null;
      }
      willAddChild_hz2iwc_k$(element) {
        var tmp0 = this.$this_1;
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (shownWhen$1())(this.$default_1, this.$this_shownWhen_1, this.$condition_1, this.$transition_1);
        ensureOutermostElement(element_0);
        tmp0.willAddChild_hz2iwc_k$(element_0);
        element_0.onStartup_vrxh3i_k$();
        tmp0.addChild_2qpft2_k$(element_0);
        var e = element_0;
        this.current_1 = e;
        e.willAddChild_hz2iwc_k$(element);
      }
      addChild_2qpft2_k$(element) {
        var tmp0_safe_receiver = this.current_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          tmp0_safe_receiver.addChild_2qpft2_k$(element);
          tmp = Unit_instance;
        }
        if (tmp == null)
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('addChild called on ' + element.toString() + ' before willAddChild!');
      }
      get_context_h02k06_k$() {
        return this.$$delegate_0__1.get_context_h02k06_k$();
      }
      invoke_bnq13k_k$(_this__u8e3s4, actionToCalculate) {
        return this.$$delegate_0__1.invoke_bnq13k_k$(_this__u8e3s4, actionToCalculate);
      }
      get_coroutineContext_115oqo_k$() {
        return this.$$delegate_0__1.get_coroutineContext_115oqo_k$();
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [KiteUiCoroutineScopeHelpers()]);
    shownWhen$$inlined$lazyInjectModifierWriter$1Class = $;
  }
  return shownWhen$$inlined$lazyInjectModifierWriter$1Class;
}
//region block: exports
export {
  PassthroughContainer as PassthroughContainertzebc7dblhz6,
  align as align3syrmjzjb5jar,
  get_asBanner as get_asBanner3lskqry4r3fmr,
  get_asListItem as get_asListItemslfszm1amipl,
  get_asMain as get_asMain94c2jepff2gk,
  get_asNavigation as get_asNavigation1puslqspkdfc0,
  dynamicSizeConstraints as dynamicSizeConstraints11edb2eqye4mg,
  setupAsListContainer as setupAsListContainer2ar7us17v5abw,
  shownForQuery as shownForQuery3qp0gj477pgv9,
  shownWhen as shownWhen3t7othivfr11,
  sizedBox as sizedBox3aolxerximlpj,
  textPopover as textPopover3tarprbgmgxbr,
  weight as weight31wqab1913ly4,
};
//endregion

//# sourceMappingURL=modifiers.commonHtml.mjs.map
